import React from 'react';

import './Link.scss';

const Link = ({ children, ...rest }) => (
  <a {...rest} className="link">
    {children}
  </a>
);

export default Link;
